export const ModalStates = {
  Review: 'review',
  Edit: 'edit',
  ConfirmEdit: 'confirmEdit',
  ResultMessage: 'resultMessage',
}